module.exports = __webpack_public_path__ + "images/vipbg3.png";